import "./App.scss";

import { RouterProvider } from "@tanstack/react-router";
import { Provider } from "react-redux";
import store from "src/datahandling/redux/store";
import { router } from "src/router";
import { InfrastructureWrapper } from "./infrastructure";

export const App = () => {
	return (
		<Provider store={store}>
			<InfrastructureWrapper>
				<RouterProvider router={router} />
			</InfrastructureWrapper>
		</Provider>
	);
};
